/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityFeedEntryDto } from './ActivityFeedEntryDto';
import {
    ActivityFeedEntryDtoFromJSON,
    ActivityFeedEntryDtoFromJSONTyped,
    ActivityFeedEntryDtoToJSON,
    ActivityFeedEntryDtoToJSONTyped,
} from './ActivityFeedEntryDto';

/**
 * Paginated response containing list of activity feed entries
 * @export
 * @interface SearchActivityFeedResponse
 */
export interface SearchActivityFeedResponse {
    /**
     * List of activity feed entries
     * @type {Array<ActivityFeedEntryDto>}
     * @memberof SearchActivityFeedResponse
     */
    items: Array<ActivityFeedEntryDto>;
    /**
     * Total number of entries matching the query
     * @type {number}
     * @memberof SearchActivityFeedResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the SearchActivityFeedResponse interface.
 */
export function instanceOfSearchActivityFeedResponse(value: object): value is SearchActivityFeedResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function SearchActivityFeedResponseFromJSON(json: any): SearchActivityFeedResponse {
    return SearchActivityFeedResponseFromJSONTyped(json, false);
}

export function SearchActivityFeedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchActivityFeedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ActivityFeedEntryDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function SearchActivityFeedResponseToJSON(json: any): SearchActivityFeedResponse {
    return SearchActivityFeedResponseToJSONTyped(json, false);
}

export function SearchActivityFeedResponseToJSONTyped(value?: SearchActivityFeedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ActivityFeedEntryDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

